/**
 * Transliteration rules for germany language.
 * @param string
 * @returns {*}
 */
function transliterationForDe(string) {
  let resultString = string;

  const exceptions = ['düsseldorf'];
  if (exceptions.includes(resultString)) {
    return resultString;
  }

  // We need braces for readability.
  /* eslint-disable quote-props */
  const transliterations = {
    'ä': 'ae',
    'ö': 'oe',
    'ü': 'ue',
    'Ä': 'Ae',
    'Ö': 'Oe',
    'Ü': 'Ue',
    'ß': 'ss',
  };
  Object.entries(transliterations).forEach(([key, value]) => {
    const regex = new RegExp(key, 'g');
    resultString = resultString.replace(regex, value);
  });

  return resultString;
}

/**
 * Doing transliteration.
 * @param string
 * @param language
 * @returns string
 */
export default function stringSanitizer(string, language) {
  let resultString = string;

  switch (language) {
    case 'fr':
      // Replace apostrophe and dashes around it to -
      resultString = resultString.replace(/(-+)?'(-+)?/g, '-');
      break;
    case 'de':
      resultString = transliterationForDe(resultString);
      break;
    // no default
  }

  return resultString
    // Replace special characters to normal latin chars. For example: é => e
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}
